var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isRotate)?_c('div',{staticClass:"gift-wrapper"},[_c('img',{staticClass:"rotateIcon",attrs:{"src":require(
      `@/assets/images/rotate_screen.gif`
  )}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }